export * from './areaCode'
export * from './api'
export * from './c2c'
export * from './scene'
export * from './wallet'
export * from './agent'
export * from './notice'

// 0会员 1码商 2商户会员 3系统码商 4商户码商
export enum UserRole {
  /** 普通用户 */
  User = 0,
  /** 商家 */
  Agent = 1,
  /** 商户会员 */
  MerchantMember = 2,
  /** 系统码商 */
  SystemAgent = 3,
  /** 商户码商 */
  MerchantAgent = 4,
}
